import { Component, inject, Input, OnInit, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationBoxComponent } from 'src/app/shared/components/confirmation-box/confirmation-box.component';
import { AlertBoxComponent } from 'src/app/shared/components/alert-box/alert-box.component';
import { QuestionsService } from '../../services/questions.service';

export interface AnswerLogEntry {
  id: number;
  expertId?: number;
  expertName: string;
  expertAvatar?: string;
  answerText: string;
  date: string;
}

@Component({
  selector: 'app-answers-log',
  standalone: false,
  templateUrl: './answers-log.component.html',
  styleUrl: './answers-log.component.scss',
})
export class AnswersLogComponent implements OnInit {
  @Input() questionId!: number;
  answers: AnswerLogEntry[] = [];

  private questionsService = inject(QuestionsService);
  private dialog = inject(MatDialog);
  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.loadAnswers();
  }

  loadAnswers(): void {
    this.questionsService.getQuestionAnswers(this.questionId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (response) => {
        this.answers = (response.data || []).map((answer: any) => ({
          id: answer.id,
          expertId: answer.expert?.id,
          expertName: answer.expert?.name || '-',
          answerText: answer.content,
          date: answer.created_at,
        }));
      },
      error: () => { this.answers = []; },
    });
  }

  deleteAnswer(entry: AnswerLogEntry): void {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      data: {
        id: entry.id,
        message: 'هل أنت متأكد من حذف هذه الإجابة؟',
      },
    });

    dialogRef.afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((result) => {
      if (!result) return;
      this.questionsService.deleteAnswer(entry.id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: () => {
          this.loadAnswers();
          this.showAlertDialog(true, 'تم حذف الإجابة بنجاح');
        },
        error: () => {
          this.showAlertDialog(false, 'عذراً لا يمكن حذف الإجابة');
        },
      });
    });
  }

  private showAlertDialog(success: boolean, message: string): void {
    this.dialog.open(AlertBoxComponent, {
      data: {
        imgSuccess: success,
        message,
        button: 'تم',
      },
    });
  }
}
